<template>
  <div>
    <div class="table-responsive">
      <table class="table table-sm table-tp table-striped table-middle fs-sm">
        <thead>
          <tr>
            <th v-if="$root.user.isAdmin" class="th-shrink" />
            <th />
            <th class="text-right bg-white">Množstvo (kWh)</th>
            <th class="text-right bg-white">Dohodnutý regulačný príkon (kW)</th>
            <th class="text-right bg-white">
              Regulačný príkon podľa skut. odberu (kW)
            </th>
            <th class="text-right bg-white">Celková cena (€ bez dph)</th>
            <th class="text-right bg-white">
              Priem. jedn. cena (€ bez dph/kWh)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in data" :key="item.id">
            <td v-if="$root.user.isAdmin">
              <b-dropdown variant="link" no-caret class="btn-p-0">
                <template slot="button-content">
                  <b-icon icon="text-indent-left" scale="1.25x" />
                </template>
                <b-dropdown-item @click.prevent="edit(item.id)">
                  <b-icon icon="pencil-square" class="mr-1" />
                  Upraviť
                </b-dropdown-item>
                <b-dropdown-item
                  class="text-danger"
                  @click.prevent="remove(item.id)"
                >
                  <b-icon icon="trash" class="mr-1" />
                  Vymazať
                </b-dropdown-item>
              </b-dropdown>
            </td>
            <td class="text-nowrap font-weight-bold">
              <template v-if="isYearly(item.reportDate)"> Celkom </template>
              <template v-else>
                {{ item.reportDate | formatMonths }}
              </template>
            </td>
            <td class="text-right">
              <template v-if="item.amount != null">
                {{ item.amount | formatNumber(2) }}
              </template>
              <template v-else> - </template>
            </td>
            <td class="text-right">
              <template v-if="item.regulationPower != null">
                {{ item.regulationPower | formatNumber(4) }}
              </template>
              <template v-else> - </template>
            </td>
            <td class="text-right">
              <template v-if="item.regulationPowerReal != null">
                {{ item.regulationPowerReal | formatNumber(4) }}
              </template>
              <template v-else> - </template>
            </td>
            <td class="text-right">
              <template v-if="item.totalPrice != null">
                {{ item.totalPrice | formatNumber(2) }}
              </template>
              <template v-else> - </template>
            </td>
            <td class="text-right">
              <template v-if="item.priceUnit != null">
                {{ item.priceUnit | formatNumber(4) }}
              </template>
              <template v-else> - </template>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td v-if="$root.user.isAdmin" />
            <td colspan="4" />
            <td class="text-right">
              <span class="fs-lg font-weight-bold">{{
                sumTotalPrice | formatNumber(2)
              }}</span>
            </td>
            <td class="text-right">
              <span class="fs-lg font-weight-bold"
                >Priem. cena: {{ avgPriceUnit | formatNumber(4) }}</span
              >
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    <b-row v-if="report" class="align-items-center mt-2 mb-4">
      <b-col cols="4" md="2" sm="2">
        <div class="text-center">
          <div>Ročné množstvo (kWh)</div>
          <hr class="my-1" />
          <h4 class="m-0">
            {{ report.totalAmount | formatNumber(2) }}
          </h4>
        </div>
      </b-col>
      <div class="col-xs-12 col-sm-2 col-md-2">
        <div class="text-center">
          <div>Ročný dohodnutý reg. príkon (kW)</div>
          <hr class="my-1" />
          <h4 class="m-0">
            {{ report.totalRegulationPower | formatNumber(4) }}
          </h4>
        </div>
      </div>
      <b-col cols="4" md="2" sm="2">
        <div class="text-center">
          <div>Ročný reg. príkon podľa skutočného odberu (kW)</div>
          <hr class="my-1" />
          <h4 class="m-0">
            {{ report.totalRegulationPowerReal | formatNumber(4) }}
          </h4>
        </div>
      </b-col>
      <b-col cols="4" md="2" sm="2">
        <div class="text-center">
          <div>Rozdiel odobraté a objednané teplo (kWh)</div>
          <hr class="my-1" />
          <h4 class="m-0">
            {{ report.diffAmOr | formatNumber(4) }}
          </h4>
        </div>
      </b-col>
      <b-col cols="4" md="2" sm="2">
        <div class="text-center">
          <div>Rozdiel odobraté a objednané teplo v %</div>
          <hr class="my-1" />
          <h4 class="m-0">
            {{ report.percDiffAmOr | formatNumber(2) }}
          </h4>
        </div>
      </b-col>
      <b-col cols="4" md="2" sm="2">
        <div class="text-center">
          <div>
            Rozdiel reg. podľa skut. odberu a ročný dohodnutý reg. príkon v %
          </div>
          <hr class="my-1" />
          <h4 class="m-0">
            {{ report.percDiffRegYear | formatNumber(2) }}
          </h4>
        </div>
      </b-col>
    </b-row>
    <heat-chart :data="chartData" />
    <hr />
    <div class="mb-5">
      <h4>
        <b-icon icon="pencil" />
        Poznámky
        <transition name="fadeRightShort">
          <b-badge v-if="noteSaved" variant="primary">
            {{ noteSaved }}
          </b-badge>
        </transition>
      </h4>
      <b-form-textarea
        v-if="$root.user.isAdmin"
        v-model="note"
        placeholder="žiadne poznámky (kliknutím pridajte)"
        rows="4"
        @blur="$emit('onNoteChange', note)"
      />
      <div
        v-else
        class="h-auto form-control"
        v-html="note ? $options.filters.nl2br(note) : '-'"
      />
    </div>
  </div>
</template>
<script>
import HeatChart from './Chart'

export default {
  components: {
    HeatChart,
  },
  props: ['chartData', 'data', 'report', 'note'],
  data() {
    return {
      noteSaved: '',
    }
  },
  computed: {
    sumTotalPrice() {
      return this.data.reduce(function (sum, item) {
        return sum + item.totalPrice
      }, 0)
    },
    avgPriceUnit() {
      let priceUnit = this.data.reduce(function (sum, item) {
        return sum + item.priceUnit
      }, 0)
      return priceUnit / this.data.length
    },
  },
  methods: {
    edit(id) {
      this.$root.$emit('reports.openConsumerModal', { id: id })
    },
    remove(id) {
      this.$parent.$parent.remove(id)
    },
    isYearly(date) {
      return this.$moment(date, 'YYYY-MM-DD').format('DD.MM') == '31.12'
        ? true
        : false
    },
  },
}
</script>
